module.exports = __webpack_public_path__ + "media/images/phone/story-script_tap-visual-f1a02af1e93a218da582180a01129ef4.png";